import type { JSX, ButtonHTMLAttributes } from "react";
import cn from "classnames";

interface ToggleProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const Toggle = (props: ToggleProps): JSX.Element => {
  const { checked, onChange, className, disabled = false, ...otherProps } = props;

  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      className={cn(
        "relative inline-flex h-[18px] w-[34px] items-center rounded-full bg-gray-100 transition-colors duration-200",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
        className,
      )}
      {...otherProps}
    >
      <span
        className={cn(
          "inline-block h-[18px] w-[18px] transform rounded-full border border-gray-300 bg-white shadow-sm transition-transform duration-200",
          checked ? "translate-x-4" : "translate-x-0",
        )}
      />
    </button>
  );
};
